import React from "react";

interface Props {
  color1?: string;
  color2?: string;
  color3?: string;
}

export const AddPersonIcon = (props: Props) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      fill={props.color3 ? props.color3 : "#D1FADF"}
    />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke={props.color2 ? props.color2 : "#ECFDF3"}
      strokeWidth="8"
    />
    <path
      d="M33.6265 22.75C33.4428 25.2283 31.564 27.25 29.5015 27.25C27.439 27.25 25.557 25.2288 25.3765 22.75C25.189 20.1719 27.0171 18.25 29.5015 18.25C31.9859 18.25 33.814 20.2188 33.6265 22.75Z"
      stroke={props.color1 ? props.color1 : "#4CAF50"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.5005 30.25C25.4224 30.25 21.2833 32.5 20.5174 36.7469C20.4236 37.2588 20.7147 37.75 21.251 37.75H37.7505C38.2868 37.75 38.5765 37.2588 38.4841 36.7469C37.7177 32.5 33.5786 30.25 29.5005 30.25Z"
      stroke={props.color1 ? props.color1 : "#4CAF50"}
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M20.125 24.25V29.5"
      stroke={props.color1 ? props.color1 : "#4CAF50"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.75 26.875H17.5"
      stroke={props.color1 ? props.color1 : "#4CAF50"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
